import { PersonStamdata } from "../../interfaces/stamdata";

/**
 * Om medlemmet er afvist fra at bestille ID-kort, fordi det ikke er udøvende advokat — i praksis
 * en advokatfuldmægtig (ADV-324).
 *
 * Afgørelsen er backendens (`MaaBestilleIdKort`, som igen kommer fra AIKA), og portalen gentager
 * den kun, så medlemmet får afslaget, FØR det udfylder formularen. `POST IdKort` afviser med 403
 * uanset hvad portalen viser.
 *
 * Kun et eksplicit `false` afviser. Feltet er tilføjet additivt og mangler i den backend, der kører
 * nu; et manglende felt må derfor ikke spærre alle advokater ude. Samme greb som `profilKlar`.
 */
export const erAfvistSomIkkeAdvokat = (
  stamdata: Pick<PersonStamdata, "maaBestilleIdKort"> | null | undefined,
): boolean => stamdata?.maaBestilleIdKort === false;
